module.exports = __webpack_public_path__ + "static/56e64cdf17fdf9c9322302ebcc407dabab0115a9348d64c1ad55d242066e339e-e4cc58e4bfa37f72bea9f2079e456312.jpeg";